<template>
  <div>
    <!-- <v-divider></v-divider> -->
    <v-layout wrap justify-center fill-height>
      <v-flex xs12 sm12 md12 lg2 hidden-md-and-down class="sidebar-print-col">
        <v-navigation-drawer style="z-index:2000;" class="fixedSidebar premium-sidebar modern-sidebar" v-model="sideNav" clipped light
          overlay-color="white" width="100%" height="100vh" permanent>
          <div class="sidebar-brand-wrapper text-left pl-6 pt-6 pb-4 position-relative">
            <router-link :to="dashboardRoute" class="sidebar-logo-link">
              <span class="sidebar-logo-main">
                <span class="sidebar-logo-text">JEWEL<span class="gold-text">BIZ</span></span>
              </span>
              <div class="sidebar-tagline">BRILLIANCE IN BUSINESS</div>
            </router-link>
          </div>
          <!---------------------------------- SuperAdmin sidebar-------------------------------------------->
          <v-layout wrap align-start>
            <v-flex xs12 text-left text-uppercase v-if="navItems && this.appType != 'Staff'">
              <v-list dense v-for="(main, i) in navItems" :key="i" class="subhed py-0">
                <v-layout wrap>
                  <v-flex xs12 py-1 px-3>
                    <router-link :to="main.menu.route" style="text-decoration: none;" @click.native="handleNavClick(main.menu)">
                    <v-list-group no-action :value="isMainMenuActive(main)" active-class="activated" :class="{ 'active-menu-pill': isMainMenuActive(main) }">
                      <template v-slot:activator>
                        <v-list-item-icon class="mr-3 my-0 align-self-center">
                          <v-icon small :color="isMainMenuActive(main) ? '#9a6b27' : '#526071'">
                            {{ getMenuIcon(main.menu.name) }}
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                          <span class="text-none menu-item-text" :class="{ 'active-text-orange': isMainMenuActive(main) }">
                            {{ formatMenuName(main.menu.name) }}
                          </span>
                        </v-list-item-title>
                      </template>
                      <!-- submenu -->
                      <!-- <v-flex xs12 py-1 px-4>
                        <div style="border-bottom: 1px dotted black"></div>
                      </v-flex> -->
                      <div v-if="main.menu.subMenu" class="subhed">
                        <template v-for="(sub, i) in main.menu.subMenu">
                          <v-flex xs12 text-left pl-6 py-1 :style="
                            $route.path == sub.route
                              ? 'background: #fbf2df; border-radius: 6px;'
                              : ''
                          " :key="i">
                            <v-layout wrap justify-center>
                              <v-flex xs12>
                                <router-link :to="sub.route">
                                  <span style="letter-spacing: 2px; cursor: pointer">
                                    <span class="text-none" :style="
                                      $route.path == sub.route
                                        ? 'color: #9a6b27; font-weight: 600;'
                                        : 'color: #566176;'
                                    " style="
                                letter-spacing: 1.5px;
                                font-size: 12px !important;
                                cursor: pointer;
                              ">
                                     -> {{ sub.name }}
                                    </span>
                                  </span>
                                </router-link>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- <v-flex xs12 py-1 px-4 pl-6 :key="sub._d">
                          <div style="border-bottom: 1px solid grey"></div>
                        </v-flex> -->
                        </template>
                      </div>

                      <div v-if="main.menu.subMenuCategories" class="report-categories-container">
                        <v-list-group
                          v-for="(cat, cIndex) in main.menu.subMenuCategories"
                          :key="'cat-'+cIndex"
                          :value="isCategoryActive(cat)"
                          sub-group
                          no-action
                          class="report-sub-group"
                        >
                          <template v-slot:activator>
                            <v-list-item-title class="report-cat-title-wrapper">
                              <span class="report-cat-title">
                                {{ formatMenuName(cat.categoryName) }}
                              </span>
                            </v-list-item-title>
                          </template>
                          
                          <div class="report-sub-items-tree">
                            <router-link
                              v-for="(sub, i) in cat.reports"
                              :key="'sub-'+i"
                              :to="sub.route"
                              class="report-sub-link d-flex align-start text-decoration-none"
                              :class="{ 'report-sub-link-active': $route.path == sub.route }"
                            >
                              <span class="report-bullet-dot"></span>
                              <span class="report-link-text">
                                {{ formatMenuName(sub.name) }}
                              </span>
                            </router-link>
                          </div>
                        </v-list-group>
                      </div>
                      <!-------------->
                    </v-list-group>
                    </router-link>
                  </v-flex>
                </v-layout>
              </v-list>
            </v-flex>
            <v-flex xs12 text-left py-2 text-uppercase v-if="navItems && this.appType == 'Staff'"><span
                style="color:white;"></span>
                <v-layout wrap align-start>
            <v-flex xs12 px-3 pb-2>
              <router-link :to="dashboardRoute" style="text-decoration: none;">
                <v-list-item class="rounded-pill" :class="{ 'active-menu-pill': isRouteActive('/StaffDashboard') }">
                  <v-list-item-icon class="mr-3 my-0 align-self-center">
                    <v-icon small :color="isRouteActive('/StaffDashboard') ? '#9a6b27' : '#526071'">
                      mdi-home
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <span class="text-none menu-item-text" :class="{ 'active-text-orange': isRouteActive('/StaffDashboard') }">
                      Dashboard
                    </span>
                  </v-list-item-title>
                </v-list-item>
              </router-link>
            </v-flex>
           </v-layout>
              <v-list dense v-for="(main, i) in navItems" :key="i" class="subhed">


                <v-layout wrap v-if="main">
                  <v-flex xs12 py-2>
                    <router-link :to="main.menu.route">
                    <v-list-group no-action :value="isRouteActive(main.menu.route)" active-class="activated" :class="{ 'active-menu-pill': isRouteActive(main.menu.route) }">
                      <template v-slot:activator>
                        <v-list-item-icon class="mr-3 my-0 align-self-center">
                          <v-icon small :color="isRouteActive(main.menu.route) ? '#9a6b27' : '#526071'">
                            {{ getMenuIcon(main.menu.name) }}
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                          <span class="text-none menu-item-text" :class="{ 'active-text-orange': isRouteActive(main.menu.route) }">
                            {{ formatMenuName(main.menu.name) }}
                          </span>
                        </v-list-item-title>
                      </template>
                      <!-- <div v-if="main.submenus" class="subhed">
                        <template v-for="(sub, i) in main.submenus">
                          <v-flex xs12 text-left pl-6 py-1 :style="
                            $route.path == sub.route
                              ? ''
                              : 'background:rgba(0, 0, 0, 0.1)'
                          " :key="i">
                            <v-layout wrap justify-center>
                              <v-flex xs12>
                                <router-link :to="sub.route">
                                  <span style="letter-spacing: 3px; cursor: pointer">
                                    <span class="text-none" :style="
                                      $route.path == sub.route
                                        ? 'color:#ffffff'
                                        : 'color: #ffffff'
                                    ">
                                      {{ sub.name }}
                                    </span>
                                  </span>
                                </router-link>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </template>
                      </div> -->
                      <!-------------->
                    </v-list-group>
                    </router-link>
                  </v-flex>
                </v-layout>
              </v-list>
            </v-flex>
          </v-layout>

          <!-- Bottom Crafting Growth Together Card -->
          <div class="sidebar-bottom-section px-4 pt-4 pb-4">
            <div class="bottom-jewellers-card d-flex align-center">
              <div class="bottom-card-icon-wrapper mr-2">
                <v-icon color="#9a6b27" size="28">mdi-diamond-outline</v-icon>
              </div>
              <div class="badge-text text-left">
                <div class="badge-line1">Crafting</div>
                <div class="badge-line2">Growth Together</div>
              </div>
            </div>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md12 lg10 pt-12 pt-lg-0 class="content-print-col">
        <AppHeader />
        <!-- to set color for dashboard bg according to user -->
        <!-- <v-layout
          wrap
          justify-center
          :style="
            $route.name == 'dashboard'
              ? 'background-color: #f5daf5'
              : 'background-color: #f5daf5'
          "
        > -->
        <v-layout wrap justify-center :class="{ 'dashboard-layout': $route.path === '/JewelleryDashboard' || $route.path === '/StaffDashboard' }" style="background-color: #fbfaf8; min-height: 100vh">
          <v-flex xs12 px-4 pt-2 pb-6 :class="{ 'dashboard-page-wrapper': $route.path === '/JewelleryDashboard' || $route.path === '/StaffDashboard' }">
            <router-view :key="$route.fullPath"></router-view>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import AppHeader from "./../layout/AppHeader";
import adminMenu from "./adminMenu";
export default {
  components: {
    AppHeader,
  },

  data() {
    return {
      sideNav: true,
      admin: [{ name: "ADMINS", route: "/Admins" }],
      menu2: [],
      // GSTstatus:localStorage.getItem("GSTstatus"),
      userNavItemsSuperAdmin: [
        {
          menu: {
            name: "Jewellery Admin",
            route: "/superadminDashboard",
          },
        },
        {
          menu: {
            name: "Jewellery Stores",
            route: "/ViewAdmin",
          },
        },
        {
          menu: {
            name: "Platform Admins",
            route: "/PlatformAdmins",
          },
        },
        {
          menu: {
            name: "Audit Log",
            route: "/SuperAdminAuditLog",
          },
        },
        {
          menu: {
            name: "Demo Requests",
            route: "/DemoRequests",
          },
        },
      ],

      userNavItemsJuwelAdmin: adminMenu,
      userNavItemsStaffAdmin: [],
    };
  },
  computed: {
    appType() {
      return this.$store.state.userType;
    },
    GSTstatus(){
    return localStorage.getItem("GSTstatus");

    },
    userNavItemsStaffAdmin1(){
      return this.$store.state.menu;

    },
    // appMenu() {
    //   console.log("menus", store.state.menus);

    //   if (this.$store.state.menus.length > 0 && localStorage.getItem("positionId") != null) {
    //     return this.$store.state.menus;
    //   } else {
    //     return this.NewEmpMenu;
    //   }

    // },
    navItems() {
      if (this.appType == "SuperAdmin") return this.userNavItemsSuperAdmin;
      else if (this.appType == "JewelleryAdmin")
        return this.userNavItemsJuwelAdmin;
      else if (this.appType == "Staff") return this.userNavItemsStaffAdmin1;
      else return this.userNavItems;
    },
    dashboardRoute() {
      if (this.appType === "SuperAdmin") return "/superadminDashboard";
      if (this.appType === "JewelleryAdmin") return "/JewelleryDashboard";
      return "/StaffDashboard";
    },
  },
  // beforeMount() {
  //   this.getMenu();
  // },
  // beforeMount() {
  //   this.userNavItemsStaffAdmin = localStorage.getItem("menu");

  //   console.log("menu", this.userNavItemsStaffAdmin);
  // },
  // watch:{
  //   userNavItemsStaffAdmin1(){
  //     this.userNavItemsStaffAdmin=this.userNavItemsStaffAdmin1;
  //     console.log("userNavItemsStaffAdmin==",this.userNavItemsStaffAdmin)
  //   }
  // },
  mounted() {
    this.$root.$on('toggle-side-nav', () => {
      this.sideNav = !this.sideNav;
    });
  },
  beforeDestroy() {
    this.$root.$off('toggle-side-nav');
  },
  methods: {
    handleNavClick(menu) {
      if (menu && (menu.name === "Jewellery Admin" || menu.route === "/superadminDashboard")) {
        if (this.$route.path === "/superadminDashboard") {
          window.dispatchEvent(new Event("scroll-to-admin-form"));
        }
      }
    },
    getMenuIcon(name) {
      if (!name) return 'mdi-circle-small';
      const map = {
        'DASHBOARD': 'mdi-home',
        'PURCHASE': 'mdi-cart-outline',
        'ISSUE & RECEIPT': 'mdi-swap-horizontal',
        'CONVERSION': 'mdi-sync',
        'ACCOUNT HEADS': 'mdi-clipboard-text-outline',
        'ACCOUNTS': 'mdi-card-account-details-outline',
        'TRIAL BALANCE': 'mdi-scale-balance',
        'PROFIT & LOSS': 'mdi-chart-line',
        'BALANCE SHEET': 'mdi-clipboard-text-outline',
        'ESTIMATE': 'mdi-tag-outline',
        'BILLING': 'mdi-receipt-text-outline',
        'STOCK': 'mdi-package-variant-closed',
        'SUPPLIER': 'mdi-truck-outline',
        'CATEGORY': 'mdi-shape-outline',
        'HSN': 'mdi-file-document-outline',
        'GOLD SCHEME': 'mdi-circle-multiple-outline',
        'SCHEME LIST': 'mdi-bookmark-outline',
        'STAFF': 'mdi-account-group-outline',
        'CUSTOMER': 'mdi-account-heart-outline',
        'SALES HISTORY': 'mdi-history',
        'BOARDING RATE': 'mdi-currency-inr',
        'OLD GOLD': 'mdi-gold',
        'REPORT': 'mdi-chart-bar',
        'REPORTS': 'mdi-chart-bar',
        'MASTERS': 'mdi-archive-outline',
        'SETTINGS': 'mdi-cog-outline',
      };
      return map[name.toUpperCase()] || 'mdi-circle-small';
    },
    formatMenuName(name) {
      if (!name) return '';
      return name
        .split(' ')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
    },
    isRouteActive(route) {
      if (!route) return false;
      if (this.$route.path === route) return true;
      if (
        route === '/PurchaseList' &&
        this.$route.path.toLowerCase().includes('purchase')
      )
        return true;
      if (
        (route === '/StaffDashboard' ||
          route === '/superadminDashboard' ||
          route === '/JewelleryDashboard') &&
        this.$route.path.toLowerCase().includes('dashboard')
      )
        return true;
      if (
        route === '/SalesList' &&
        (this.$route.path.toLowerCase().includes('sales') ||
          this.$route.path.toLowerCase().includes('billing'))
      )
        return true;
      if (
        route === '/EstimatePage' &&
        this.$route.path.toLowerCase().includes('estimate')
      )
        return true;
      if (
        route === '/StockPage' &&
        this.$route.path.toLowerCase().includes('stock')
      )
        return true;
      return false;
    },
    isCategoryActive(cat) {
      if (!cat || !cat.reports) return false;
      return cat.reports.some((r) => r.route === this.$route.path);
    },
    isMainMenuActive(main) {
      if (!main || !main.menu) return false;
      if (main.menu.subMenuCategories) {
        return main.menu.subMenuCategories.some((cat) =>
          cat.reports && cat.reports.some((r) => r.route === this.$route.path)
        );
      }
      if (main.menu.route) return this.isRouteActive(main.menu.route);
      return false;
    },
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500;700&family=Inter:wght@400;500;600;700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

.modern-sidebar,
.premium-sidebar {
  background:
    url('../assets/images/sidebar_wave.svg') no-repeat bottom right / 100% auto,
    linear-gradient(180deg, #fffdfa 0%, #fff7ee 35%, #faecd8 75%, #f6debf 100%) !important;
  background-color: #fff7ee !important;
  border-right: 1px solid #f0decb !important;
  display: flex !important;
  flex-direction: column !important;
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif !important;
}

.modern-sidebar .v-navigation-drawer__content,
.premium-sidebar .v-navigation-drawer__content {
  background: transparent !important;
  background-color: transparent !important;
  display: flex !important;
  flex-direction: column !important;
}

.modern-sidebar .v-navigation-drawer__border {
  background-color: #f0decb !important;
  width: 1px !important;
}

.modern-sidebar .v-list,
.premium-sidebar .v-list {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-sidebar .v-list-item,
.modern-sidebar .v-list-group__header,
.premium-sidebar .v-list-item,
.premium-sidebar .v-list-group__header {
  background: transparent !important;
  background-color: transparent !important;
  min-height: 40px !important;
  border-radius: 8px !important;
  padding: 0 12px !important;
  margin-bottom: 2px !important;
}

.sidebar-brand-wrapper {
  position: relative;
}

.sidebar-logo-link {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}

.sidebar-logo-main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
}

.sidebar-logo-text {
  font-family: 'Cinzel', 'Plus Jakarta Sans', serif;
  font-size: 22px;
  font-weight: 700;
  color: #172238 !important;
  letter-spacing: 2.5px;
  line-height: 1.2;
}

.gold-text {
  color: #9a6b27 !important;
}

.demo-badge-sidebar {
  font-family: 'Plus Jakarta Sans', sans-serif !important;
  font-size: 10px !important;
  background: rgba(184, 106, 36, 0.12) !important;
  border: 1px solid rgba(184, 106, 36, 0.35) !important;
  color: #9a6b27 !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
  font-weight: 600 !important;
  vertical-align: middle !important;
  margin-left: 8px !important;
  letter-spacing: 0.5px !important;
  display: inline-block !important;
  text-transform: uppercase;
}

.sidebar-tagline {
  font-family: 'Plus Jakarta Sans', sans-serif !important;
  font-size: 9px;
  letter-spacing: 2px;
  color: #8c7355 !important;
  font-weight: 500;
  margin-top: 5px;
  white-space: nowrap;
}

.sidebar-edge-toggle {
  position: absolute;
  right: -10px;
  top: 24px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #e2ddf0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2100;
  box-shadow: 0 2px 5px rgba(0,0,0,0.12);
  transition: transform 0.2s ease;
}

.sidebar-edge-toggle:hover {
  transform: scale(1.1);
}

.menu-item-text {
  font-family: 'Plus Jakarta Sans', sans-serif !important;
  font-weight: 500 !important;
  font-size: 13.5px !important;
  letter-spacing: -0.01em !important;
  color: #334155 !important;
  transition: color 0.2s ease;
}

.modern-sidebar .v-icon,
.modern-sidebar .v-list-item__icon,
.premium-sidebar .v-icon,
.premium-sidebar .v-list-item__icon {
  color: #526071 !important;
  transition: color 0.2s ease;
}

/* Active Item matching reference image */
.active-menu-pill {
  background: #fae4cb !important;
  border-radius: 8px !important;
  position: relative !important;
}

.active-menu-pill::before {
  content: '' !important;
  position: absolute !important;
  left: -12px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 4px !important;
  height: 24px !important;
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important; background-color: #9a6b27 !important;
  border-radius: 0 4px 4px 0 !important;
}

.active-menu-pill .v-icon,
.active-menu-pill .v-list-item__icon,
.active-menu-pill .v-list-item__title,
.active-menu-pill .menu-item-text {
  color: #9a6b27 !important;
  font-weight: 700 !important;
}

.active-text-orange,
.active-text-gold,
.active-text-white {
  color: #9a6b27 !important;
  font-weight: 700 !important;
}

.v-list-item:hover,
.v-list-group__header:hover {
  background: rgba(250, 226, 197, 0.45) !important;
  border-radius: 8px !important;
}

.v-list-item:hover .menu-item-text,
.v-list-group__header:hover .menu-item-text {
  color: #9a6b27 !important;
}

.v-list-item:hover .v-icon,
.v-list-group__header:hover .v-icon {
  color: #9a6b27 !important;
}

/* Bottom Badge */
.sidebar-bottom-section {
  margin-top: auto;
}

.bottom-jewellers-card {
  background: transparent !important;
  border: none !important;
}

.bottom-card-icon-wrapper {
  background: transparent !important;
  border: none !important;
  width: 34px !important;
  height: 34px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
}

.badge-line1 {
  font-family: 'Plus Jakarta Sans', sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #78350f !important;
  line-height: 1.25 !important;
}

.badge-line2 {
  font-family: 'Plus Jakarta Sans', sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #78350f !important;
  line-height: 1.25 !important;
}

.activated {
  background: #fae4cb !important;
}

/* Reports Subcategories & Tree Navigation */
.report-categories-container {
  padding: 4px 0 8px 0 !important;
}

.modern-sidebar .v-list-group--sub-group.report-sub-group {
  margin: 2px 0 !important;
}

.modern-sidebar .v-list-group--sub-group.report-sub-group .v-list-group__header {
  padding-left: 10px !important;
  padding-right: 6px !important;
  min-height: 32px !important;
  height: 32px !important;
  margin: 1px 0 !important;
  border-radius: 6px !important;
  border: none !important;
  border-left: none !important;
  background: transparent !important;
  transition: background-color 0.18s ease !important;
}

.modern-sidebar .v-list-group--sub-group.report-sub-group .v-list-group__header.activated,
.modern-sidebar .v-list-group--sub-group.report-sub-group .v-list-group__header--active,
.modern-sidebar .v-list-group--sub-group.report-sub-group.v-list-group--active > .v-list-group__header {
  border-left: none !important;
  border: none !important;
  background: transparent !important;
}

.modern-sidebar .v-list-group--sub-group.report-sub-group .v-list-group__header:hover {
  background: rgba(250, 226, 197, 0.45) !important;
}

.modern-sidebar .v-list-group--sub-group.report-sub-group .v-list-group__header__prepend-icon {
  margin-right: 6px !important;
  min-width: 18px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  align-self: center !important;
}

.modern-sidebar .v-list-group--sub-group.report-sub-group .v-list-group__header__prepend-icon .v-icon {
  font-size: 16px !important;
  color: #8c7355 !important;
  transition: transform 0.2s ease !important;
}

.report-cat-title-wrapper {
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
}

.report-cat-title {
  font-family: 'Plus Jakarta Sans', sans-serif !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  color: #1e293b !important;
  letter-spacing: 0.4px !important;
  text-transform: uppercase !important;
}

.report-sub-items-tree {
  margin-left: 18px !important;
  padding-left: 10px !important;
  padding-right: 4px !important;
  padding-top: 2px !important;
  padding-bottom: 4px !important;
  border-left: 1.5px solid #ebd9c2 !important;
  display: flex !important;
  flex-direction: column !important;
}

.report-sub-link {
  padding: 5px 8px !important;
  margin: 1.5px 0 !important;
  border-radius: 6px !important;
  text-decoration: none !important;
  transition: all 0.18s ease-in-out !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: flex-start !important;
}

.report-sub-link:hover {
  background: rgba(250, 226, 197, 0.45) !important;
}

.report-sub-link:hover .report-link-text {
  color: #9a6b27 !important;
  font-weight: 600 !important;
}

.report-sub-link:hover .report-bullet-dot {
  background-color: #9a6b27 !important;
}

.report-sub-link-active {
  background: #fae4cb !important;
  box-shadow: inset 2px 0 0 #9a6b27 !important;
}

.report-sub-link-active .report-link-text {
  color: #9a6b27 !important;
  font-weight: 700 !important;
}

.report-sub-link-active .report-bullet-dot {
  background-color: #9a6b27 !important;
  transform: scale(1.3) !important;
}

.report-bullet-dot {
  width: 5px !important;
  height: 5px !important;
  min-width: 5px !important;
  min-height: 5px !important;
  border-radius: 50% !important;
  background-color: #a0aec0 !important;
  margin-top: 5px !important;
  margin-right: 7px !important;
  flex-shrink: 0 !important;
  transition: all 0.18s ease-in-out !important;
}

.report-link-text {
  font-family: 'Plus Jakarta Sans', sans-serif !important;
  font-size: 11.5px !important;
  font-weight: 500 !important;
  color: #526071 !important;
  letter-spacing: -0.01em !important;
  line-height: 1.35 !important;
  transition: color 0.18s ease-in-out !important;
  word-break: break-word !important;
}

.dashboard-layout {
  background-color: #fbfaf8 !important;
}

.dashboard-layout .dashboard-page-wrapper {
  padding: 0 !important;
}

.deactivated {
  color: inherit !important;
}

.v-list-group__header__append-icon {
  display: none !important;
}

@media only screen and (min-device-width: 767px) {
  .fixedSidebar {
    position: -webkit-sticky;
    position: sticky;
    top: 50;
  }
}

@media only screen and (min-device-width: 360px) and (max-device-width: 640px) {
  .fixedSidebar {
    display: none !important;
  }
}

/* Pages that print a report (window.print()) rely on this to hide the app
   chrome -- component-level @media print rules can't reach these elements
   since they live in this layout, not in the page component. */
@media print {
  .sidebar-print-col,
  #appNavbar {
    display: none !important;
  }

  .content-print-col {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding-top: 0 !important;
  }
}
</style>
